// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"313":"e29d8098","858":"217afbed"}[chunkId] + ".chunk.js";
};